import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitName',
  standalone: true
})
export class SplitNamePipe implements PipeTransform {

  transform(fullName: string): { name: string; lastName: string } {
    const parts = fullName.trim().split(/\s+/);

    let name = '';
    let lastName = '';

    switch (parts.length) {
      case 1:
        name = parts[0];
        break;

      case 2:
        [name, lastName] = parts;
        break;

      case 3:
        name = parts[0];
        lastName = parts.slice(1).join(' ');
        break;

      default:
        name = parts.slice(0, 2).join(' ');
        lastName = parts.slice(2).join(' ');
        break;
    }

    return { name, lastName };
  }

}
